import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button, Icon, } from '@folio/stripes/components';
export var GroupByOrgActionMenuItem = function (_a) {
    var onClick = _a.onClick;
    return (React.createElement(Button, { "data-testid": "group-by-org-button", buttonStyle: "dropdownItem", onClick: onClick },
        React.createElement(Icon, { icon: "house" },
            React.createElement(FormattedMessage, { id: "ui-claims.claiming.action.groupByOrganization" }))));
};
